// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TFInfo } from './TFInfo';

export class ReloadHistoryParams {
    public count: number | undefined = undefined;
    public callBack: any;
    public userPin: any;
    public userId: any;
    public route: any;
    public RouteId: any;
    public symbol: any;

    public UseDefaultInstrumentHistoryType: boolean = false;
    public FromTime: Date = new Date();
    public ToTime: Date = new Date();

    public TimeFrameInfo: any;

    public InstrumentID: any = -1;
    public IsContinious: boolean = false;
    public InstrumentTradableID: any = null;

    public InstrumentFullName: string = '';

    public Plan: any = null;
    public NeedApplySpreadPlan: boolean = false;
    public NeedLoadSecondPartOfHistory: boolean = false;

    /**
     * Aggregated by server if true
     */
    public ShouldCheckAggregatedPeriods: boolean = false;

    constructor (hp: ReloadHistoryParams | undefined = undefined) {
        this.fill(hp);
    }

    private fill (hp: ReloadHistoryParams | undefined): void {
        this.TimeFrameInfo = new TFInfo();
        if (hp === undefined) {
            return;
        }
        this.count = hp.count;
        this.callBack = hp.callBack;

        this.userPin = hp.userPin;
        this.route = hp.route;

        this.UseDefaultInstrumentHistoryType = hp.UseDefaultInstrumentHistoryType;

        this.FromTime = hp.FromTime;
        this.ToTime = hp.ToTime;

        this.TimeFrameInfo = hp.TimeFrameInfo.Copy();

        this.symbol = hp.symbol;
        this.userId = hp.userId;

        this.InstrumentID = hp.InstrumentID;
        this.IsContinious = hp.IsContinious;
        this.InstrumentTradableID = hp.InstrumentTradableID;
        this.InstrumentFullName = hp.InstrumentFullName;

        this.Plan = hp.Plan;
        this.NeedApplySpreadPlan = hp.NeedApplySpreadPlan;
        this.NeedLoadSecondPartOfHistory = hp.NeedLoadSecondPartOfHistory;
        this.ShouldCheckAggregatedPeriods = hp.ShouldCheckAggregatedPeriods;
    }
}
